<template>
    <v-app-bar app fixed :height="headerHeight" :color="headerColor" flat class="header">
        <!-- Logo/Nombre empresa -->
        <v-toolbar-title @click="goToHome" class="logo-text">
            AT Innovations Solutions
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- Versión Desktop - Compacta -->
        <div class="d-none d-md-flex compact-nav">
            <v-btn text x-small @click="scrollToSection('services')">Servicios</v-btn>
            <v-btn text x-small @click="scrollToSection('benefits')">Beneficios</v-btn>
            <v-btn text x-small @click="scrollToSection('testimonials')">Testimonios</v-btn>
            <v-btn text x-small @click="scrollToSection('contact')">Contacto</v-btn>
            <!-- <v-btn color="primary" x-small class="ml-2 demo-btn">Demo</v-btn> -->
        </div>

        <!-- Menú Hamburguesa (Mobile) -->
        <v-app-bar-nav-icon class="d-md-none" @click="drawer = !drawer" :size="28"></v-app-bar-nav-icon>

        <!-- Menú Mobile Compacto -->
        <v-navigation-drawer v-model="drawer" temporary right fixed :width="220" class="mobile-menu"
            style="height: 250px;">
            <v-list dense>
                <v-list-item v-for="(item, index) in menuItems" :key="index" @click="navToSection(item.section)"
                    class="compact-item">
                    <v-icon small left>{{ item.icon }}</v-icon>
                    <v-list-item-title class="text-caption">{{ item.title }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </v-app-bar>
</template>

<script>
export default {
    data() {
        return {
            drawer: false,
            headerHeight: 56, // Altura reducida del header
            isScrolled: false, // Indica si el usuario ha hecho scroll
            headerColor: 'white', // Color inicial del header
            menuItems: [
                { section: 'services', title: 'Servicios', icon: 'mdi-code-tags' },
                { section: 'benefits', title: 'Beneficios', icon: 'mdi-star-circle' },
                { section: 'testimonials', title: 'Testimonios', icon: 'mdi-account-voice' },
                { section: 'contact', title: 'Contacto', icon: 'mdi-email' },
                // { section: 'contact', title: 'Solicitar Demo', icon: 'mdi-account-tie', highlight: true }
            ]
        };
    },
    computed: {
        textColor() {
            return this.isScrolled ? 'black--text' : 'white--text'; // Cambia el color del texto
        },
    },
    methods: {
        navToSection(sectionId) {
            this.drawer = false;
            setTimeout(() => {
                this.scrollToSection(sectionId);
            }, 300);
        },
        // scrollToSection(sectionId) {
        //     const element = document.getElementById(sectionId);
        //     if (element) {
        //         element.scrollIntoView({ behavior: 'smooth' });
        //     } else {
        //         this.$router.push('/').then(() => {
        //             setTimeout(() => {
        //                 const el = document.getElementById(sectionId);
        //                 if (el) el.scrollIntoView({ behavior: 'smooth' });
        //             }, 500);
        //         });
        //     }
        // },
        scrollToSection(sectionId) {
            const element = document.getElementById(sectionId);
            if (element) {
                // Calculamos la altura del header (56px en este caso)
                const headerHeight = 56;
                // Calculamos la posición del elemento
                const elementPosition = element.getBoundingClientRect().top;
                // Calculamos la posición actual del scroll
                const offsetPosition = window.pageYOffset + elementPosition - headerHeight;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            } else {
                this.$router.push('/').then(() => {
                    setTimeout(() => {
                        const el = document.getElementById(sectionId);
                        if (el) {
                            const headerHeight = 56;
                            const elementPosition = el.getBoundingClientRect().top;
                            const offsetPosition = window.pageYOffset + elementPosition - headerHeight;

                            window.scrollTo({
                                top: offsetPosition,
                                behavior: 'smooth'
                            });
                        }
                    }, 500);
                });
            }
            // // Busca el elemento en la página actual
            // const element = document.getElementById(sectionId);

            // if (element) {
            //     // Si el elemento existe, desplázate a él
            //     element.scrollIntoView({ behavior: 'smooth' });
            // } else {
            //     // Si el elemento no existe, redirige a la página principal
            //     this.$router.push('/').then(() => {
            //         // Espera un breve momento para que la página se cargue completamente
            //         setTimeout(() => {
            //             // Busca el elemento nuevamente en la página principal
            //             const elementInHome = document.getElementById(sectionId);
            //             if (elementInHome) {
            //                 elementInHome.scrollIntoView({ behavior: 'smooth' });
            //             } else {
            //                 console.error(`Elemento con ID ${sectionId} no encontrado en la página principal.`);
            //             }
            //         }, 500); // Ajusta el tiempo de espera según sea necesario
            //     });
            // }
        },
        handleScroll() {
            // Cambia el estado de isScrolled y el color del header basado en la posición del scroll
            if (window.scrollY > 580) {
                this.isScrolled = false;
                this.headerColor = 'black'; // Cambia a un fondo claro
            } else {
                this.isScrolled = true;
                this.headerColor = 'white'; // Vuelve a ser transparente
            }
        },
        goToHome() {
            // Redirige a la página principal
            this.$router.push('/');
        },
    },
    mounted() {
        // Agrega un listener de scroll al montar el componente
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        // Remueve el listener de scroll al desmontar el componente
        window.removeEventListener('scroll', this.handleScroll);
    },
};
</script>

<style scoped>
/* Header compacto */
.header {
    z-index: 1000;
    transition: all 0.3s;
}

.logo-text {
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    margin-left: 8px;
}

/* Navegación desktop compacta */
.compact-nav {
    margin-right: 12px;
}

.compact-nav .v-btn {
    min-width: 0;
    padding: 0 8px;
    font-size: 0.75rem;
}

/* Menú móvil compacto */
.mobile-menu {
    top: 56px !important;
    padding-top: 8px;
    height: 200px;
}

.compact-item {
    min-height: 40px !important;
    padding: 0 12px !important;
}

.compact-item .v-icon {
    font-size: 18px;
}

/* Efectos hover */
.compact-item:not(.highlight):hover {
    background: rgba(255, 255, 255, 0.1);
}

/* Responsive para móviles muy pequeños */
@media (max-width: 400px) {
    .logo-text {
        font-size: 1rem;
    }

    .mobile-menu {
        width: 180px !important;
        height: 200px !important;
    }
}
</style>